import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83c47eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pricvacy-policy article" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { id: "not-found" }, "404", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, {
      class: "a to-home",
      to: "/home"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("to-home")), 1)
      ]),
      _: 1
    })
  ]))
}